import { render, staticRenderFns } from "./ProductItemCard.vue?vue&type=template&id=7e9387dc&"
import script from "./ProductItemCard.vue?vue&type=script&lang=js&"
export * from "./ProductItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports